import { FunctionalComponent, h } from 'preact';

import { i18nTranslate } from 'common/helper/i18n/translate';
import { linkPhoneFormatter } from 'common/helper/link/phone/formatter';
import { AgentListCommonTemplatePropsInterface } from 'common/module/agent/list-common/template-props.interface';
import { ProgressiveImageComponent } from 'common/module/progressive-image/component';

export const BuildingReviewAgentTemplate: FunctionalComponent<AgentListCommonTemplatePropsInterface> = (props) => {
  if (!props || !props.agents || !props.agents.length) {
    return null;
  }

  const agentProps = props.agents[0];

  const agentPropertiesCount =
    agentProps.agent.properties_residential_for_rent_count +
    agentProps.agent.properties_residential_for_sale_count +
    agentProps.agent.properties_commercial_count;

  return (
    <div
      className='featured-agent building-specialist__featured-agent'
      onClick={(e: Event) => agentProps.onClickAgent(e, agentProps.agent)}
    >
      <div className='featured-agent__image-area building-specialist__image-area'>
        <ProgressiveImageComponent
          src={agentProps.agent.public_image_large}
          classname='featured-agent__image  building-specialist__image'
          alt={agentProps.agent.name}
          placeholder={__('assets/common/agent-tile-placeholder.jpg')}
          preloader={__('assets/common/image-loader.svg')}
        />
        <div className='featured-agent__verified-tag'>
          <span
            className='svg'
            dangerouslySetInnerHTML={{
              __html: `
            <svg viewBox='0 0 512 512' class='featured-agent__verified-tag-icon'>
              <use xlink:href='#svg-star'></use>
            </svg>
            `,
            }}
          />
          {i18nTranslate(props.forSale ? 'Sales Expert' : 'Leasing Expert')}
        </div>
      </div>
      <div className='featured-agent__content-area  building-specialist__content-area'>
        <a href={agentProps.agent.links.profile} className='featured-agent__name'>
          {agentProps.agent.name}
        </a>
        <a href={agentProps.agent.links.profile} className='featured-agent__property-list'>
          {agentPropertiesCount}
          &nbsp;
          {agentPropertiesCount === 1 ? i18nTranslate('Listing') : i18nTranslate('Listings')}
        </a>
        <div className='featured-agent__agent-detail-area building-specialist__agent-detail-area'>
          <div className='featured-agent__agent-detail'>
            <div className='featured-agent__label'>{i18nTranslate('Title')}</div>
            <div className='featured-agent__content building-specialist__content'>{agentProps.agent.position}</div>
          </div>
          <div className='featured-agent__agent-detail'>
            <div className='featured-agent__label'>{i18nTranslate('Company')}</div>
            <div className='featured-agent__content building-specialist__content'>{agentProps.agent.broker.name}</div>
          </div>
        </div>
        <div className='featured-agent__actions  building-specialist__actions'>
          <a
            href={linkPhoneFormatter(agentProps.agent.public_phone)}
            className='button
              button--light
              button--size4
              button__call--property
              featured-agent__action
              building-specialist__action'
            data-qs='cta'
            onClick={(e: Event) => agentProps.onClickCall(e, agentProps.agent)}
          >
            <span
              className='svg'
              dangerouslySetInnerHTML={{
                __html: `
              <svg viewBox='0 0 15 15' class='button__icon--style3'>
                <use xlink:href='#svg-phone-icon'></use>
              </svg>
              `,
              }}
            />
            {agentProps.action.showPhoneNumber ? (
              <span className='button__text button__text-value button__phone-ltr'>{agentProps.agent.public_phone}</span>
            ) : (
              i18nTranslate('Call')
            )}
          </a>
          <span
            className='button
              button--light
              button--size4
              button__call--property
              featured-agent__action
              building-specialist__action'
            data-qs='cta'
            onClick={(e: Event) => agentProps.onClickEmail(e, agentProps.agent)}
          >
            <span
              className='svg'
              dangerouslySetInnerHTML={{
                __html: `
              <svg viewBox='0 0 20 16' class='button__icon--style3'>
                <use xlink:href='#svg-envelope-icon'></use>
              </svg>
              `,
              }}
            />
            {i18nTranslate('Email')}
          </span>
        </div>
      </div>
    </div>
  );
};
